<template>
    <div>
        <nav class="navbar navbar-custom navbar-static-top" >
            <div class="container">
                <div class="navbar-header"  style="margin:0px !important;">
                    <button type="button" class="navbar-toggle collapsed"  
                                          data-toggle="collapse"  data-target="#navbar_collapse"  aria-expanded="false">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>

                    <router-link to="/" class="navbar-brand"><img src="/images/fs-logo.png" height=32px style="float:left; position:relative; top:-5px; margin-right:5px;"><b>FiledSafely&trade;</b></router-link>
                    
                </div>

                <!-- Collect the nav links, forms, and other content for toggling -->
                <div class="collapse navbar-collapse pull-right" id="navbar_collapse">
                    <ul class="nav navbar-nav text-right"  style="z-index:20 !important;">
                        <li  v-if="1==1  &&  is_logged_in == false">
                            <router-link to="/testimonials"  data-toggle="collapse" data-target="#navbar_collapse"
                                                         style="padding-top:16px;">Testimonials</router-link>
                        </li>
                        <li>
                            <router-link to="/faq"       data-toggle="collapse" data-target="#navbar_collapse"
                                                         style="padding-top:16px;">Find out more</router-link>
                        </li>
                        <li>
                            <router-link to="/pricing"   data-toggle="collapse" data-target="#navbar_collapse"
                                                         style="padding-top:16px;">Pricing</router-link>
                        </li>
                        <li  v-if="is_logged_in">
		                    <router-link to="/emails"    data-toggle="collapse" data-target="#navbar_collapse"
                                                         style="padding-top:16px;"><i class="fas fa-envelope"></i>&nbsp;Emails</router-link>
                        </li>
                        <li  v-if="is_logged_in">
		                    <router-link to="/files"     data-toggle="collapse" data-target="#navbar_collapse"
                                                         style="padding-top:16px;"><i class="fas fa-file"></i>&nbsp;Files</router-link>
                        </li>
                        <li  v-if="is_logged_in"> 
                            <router-link to="/settings"  data-toggle="collapse" data-target="#navbar_collapse"
                                                         style="padding-top:16px;"><i class="fas fa-cog"></i>&nbsp;Settings</router-link>
                        </li>
                        <li  v-if="is_logged_in">
                            <a @click="log_out()"        data-toggle="collapse" data-target="#navbar_collapse" href=#>Logout</a>
                        </li>
                        <li  v-if="is_logged_in == false">
                            <router-link to="/login"     data-toggle="collapse" data-target="#navbar_collapse"
                                                         style="padding-top:16px; color:blue;"><i class="fas fa-lock"></i>&nbsp;Login</router-link>
                        </li>
                        <li  v-if="is_logged_in == false">
                            <router-link to="/register"  data-toggle="collapse" data-target="#navbar_collapse" style="padding-top:10px; padding-bottom:0px;">
                                <div class="btn btn-warning"  style="border:0px; margin:0px;">
                                    <b>Sign up</b>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import EventBus from '@/event_bus';					// Event Bus

export default {
	components: {
        EventBus
	},

	data() {
		return {
			env:                        process.env.VUE_APP_ENV,
			api_token:                  '',
		}
	},

	created() {
	},
	
	mounted() {
        EventBus.$on('refresh_header_api_token', (api_token) => {
            this.api_token = api_token;
        });
	},
	
	computed: {
		is_logged_in() {
			var status     = false;
			this.api_token = localStorage.getItem('api_token');
			
			if (this.api_token  &&  this.api_token.length == 64) {
				status = true;
			}	
				
			return status;
		},

		user() {
			return this.$store.getters.USER;
		},
	},

	methods: {		
		log_out() {
            localStorage.removeItem('api_token');

            const post_data = {
				api_token: this.api_token,
			};
			
			this.axios.post("api/logout", post_data)
			.then(response => {
				this.$store.commit("RESET");
                this.api_token = null;

				this.$parent.rerender_header();

				this.$notify({
					group: 'fs_success',
					title: 'Success',
					text:  'You have logged out.',
					type:  'success'
				});

				this.$router.push("/");
			})
			.catch(error => {
				this.$store.commit("RESET");
                this.api_token = null;

				this.$parent.rerender_header();
				//this.$router.push("/");

				this.$notify({
					group: 'fs_danger',
					title: 'Error',
					text:  error.response.data.message,
					type:  'error'
				});
			});
		},
	}
};
</script>
